import _, { isBuffer } from "lodash";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { getFormatted } from "helpers/formatting";
import moment from "moment";

const alignTextRight = (doc, txt, x, y) => {
  const fontSize = doc.internal.getFontSize();
  const txtWidth =
    (doc.getStringUnitWidth(txt) * fontSize) / doc.internal.scaleFactor;
  return doc.text(txt, x - txtWidth, y);
};

const renderPdfHeader = (
  showCertificates,
  doc: jsPDF,
  deliveryId,
  deliveryNote,
  seller,
  supplier?
) => {
  let tempLines: any[] = [];
  let addLines = 0;
  let linePoint = deliveryNote.logo ? 19 : 20;
  let certificates: any = [];
  if (showCertificates) {
    certificates = supplier?.Certificates?.length
      ? supplier.Certificates?.slice(0, 2)
      : seller?.Certificates?.slice(0, 2);
  }

  if (deliveryNote.logo) {
    const logo = document.getElementById("cnb-logo") as HTMLImageElement;
    doc.addImage(logo, "JPEG", 136, 10, 61, 22.5);
    doc.setFontSize(9);
    doc.line(11, 10, 131, 10);
    doc.line(11, 42, 131, 42);
    doc.line(11, 82, 209, 82);
    doc.text("Geleverd door", 11, 15);
    doc.text("Geleverd aan", 11, 47);
    doc.text(deliveryNote.deleveryTypeId, 113, 47);
  }
  doc.setFontSize(10);
  doc.text(_.get(seller, "Name", ""), 11, linePoint);

  if (supplier) {
    linePoint = linePoint + 4;
    doc.text(`VOORKEURKWEKER: ${_.get(supplier, "Name", "")}`, 11, linePoint);
  }

  doc.text(_.get(seller, "PrimaryAddress.Address1", ""), 11, linePoint + 4);
  let temp =
    _.get(seller, "PrimaryAddress.ZipCode", "") +
    " " +
    _.get(seller, "PrimaryAddress.City", "");
  doc.text(temp, 11, linePoint + 8);

  linePoint = deliveryNote.logo ? 51 : 48;

  doc.text(_.get(deliveryNote, "buyer.Name", ""), 11, linePoint);
  doc.text(
    _.get(deliveryNote, "buyer.PrimaryAddress.Address1", ""),
    11,
    linePoint + 4
  );
  temp =
    _.get(deliveryNote, "buyer.PrimaryAddress.ZipCode", "") +
    " " +
    _.get(deliveryNote, "buyer.PrimaryAddress.City", "");
  doc.text(temp, 11, linePoint + 8);
  doc.text(_.get(deliveryNote, "buyer.OfficeNumber", ""), 11, linePoint + 12);
  doc.text(_.get(deliveryNote, "buyer.MailAddress", ""), 11, linePoint + 16);

  doc.text(_.get(deliveryNote, "address.Address1", ""), 113, linePoint);
  doc.text(
    _.get(deliveryNote, "address.ZipCode", "") +
      " " +
      _.get(deliveryNote, "address.City", ""),
    113,
    linePoint + 4
  );

  if (deliveryNote.logo) {
    doc.setFontSize(9);
    doc.text("Frankeringsvoorschrift", 39, 86);
    doc.text("Vervoer per", 72, 86);
    doc.text("Plaats van verzending", 134, 86);
    doc.text("Datum", 174, 86);
  }

  doc.setFontSize(10);
  linePoint = deliveryNote.logo ? 91.5 : 78;

  doc.text(
    _.get(deliveryNote, "transport.freightCosts.label", ""),
    39,
    linePoint
  );

  tempLines = doc.splitTextToSize(
    _.get(deliveryNote, "transport.transporter", ""),
    45
  );
  doc.text(tempLines, 72, linePoint);
  addLines = tempLines.length - 1;

  tempLines = doc.splitTextToSize(
    _.get(deliveryNote, "transport.cityShipment", ""),
    40
  );
  doc.text(tempLines, 134, linePoint);
  addLines = tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;

  doc.text(getFormatted(_.get(deliveryNote, "date"), "date"), 174, linePoint);

  if (deliveryNote.logo) {
    doc.line(
      11,
      linePoint + 1.5 + 4 * addLines,
      209,
      linePoint + 1.5 + 4 * addLines
    );
    doc.line(19, 82, 19, linePoint + 1.5 + 4 * addLines);
    doc.line(196, 82, 196, linePoint + 1.5 + 4 * addLines);
  }

  doc.setFontSize(9);
  linePoint = deliveryNote.logo
    ? linePoint + 10 + 4 * addLines
    : linePoint + 10 + 4 * addLines;
  doc.text("Leveringsnota volgnummer", 18, linePoint);
  doc.text("Pagina", 18, linePoint + 4);
  doc.text("CNB relatienummer", 18, linePoint + 10);
  doc.text("BKD registratienummer", 18, linePoint + 14);
  doc.text("Naktuinbouw nummer", 18, linePoint + 18);
  doc.text("Fytosanitair nummer", 18, linePoint + 22);

  if (certificates?.length) {
    doc.text("Registratienummer(s)", 18, linePoint + 26);
  }

  doc.setFontSize(10);
  doc.text(deliveryId, 62, linePoint);

  doc.setFont("helvetica", "bold");
  doc.text("LEVERINGSNOTA/VRACHTBRIEF", 105, linePoint + 4);

  doc.line(11, linePoint + 6, 209, linePoint + 6);

  doc.text(_.get(seller, "Number", ""), 62, linePoint + 10);
  doc.text(_.get(seller, "BKDNumber") || "-", 62, linePoint + 14);
  doc.text(_.get(seller, "NAKTNumber") || "-", 62, linePoint + 18);
  doc.text(
    _.get(deliveryNote, "fytosanitairNumber") || "-",
    62,
    linePoint + 22
  );

  if (certificates?.length) {
    const registrationNumbers = certificates
      .map((certificate) => certificate.RegistrationNumber)
      .join(", ");
    doc.text(`${registrationNumbers}*`, 62, linePoint + 26);
  }

  doc.text("EU Kwaliteit - NL", 105, linePoint + 14);

  return { doc, linePoint };
};

const renderAreaalPdfHeader = (doc: jsPDF) => {
  const linePoint = 19.5;
  const logo = document.getElementById("cnb-logo") as HTMLImageElement;
  doc.addImage(logo, "JPEG", 15, 5, 40, 18);
  doc.setFontSize(8);

  return { doc, linePoint };
};

const renderOrderLinesHeader = (doc: jsPDF, linePoint) => {
  doc.setFontSize(8);
  doc.line(11, linePoint, 209, linePoint);
  doc.line(11, linePoint + 8, 209, linePoint + 9);
  doc.setFont("helvetica", "bolditalic");
  doc = alignTextRight(doc, "Aantal", 23, linePoint + 3.5);
  doc = alignTextRight(doc, "fust", 23, linePoint + 7);
  doc = alignTextRight(doc, "Aantal", 42, linePoint + 3.5);
  doc = alignTextRight(doc, "per fust", 42, linePoint + 7);
  doc = alignTextRight(doc, "Aantal", 62, linePoint + 3.5);
  doc = alignTextRight(doc, "rest fust", 62, linePoint + 7);
  doc = alignTextRight(doc, "Aantal", 82, linePoint + 3.5);
  doc = alignTextRight(doc, "totaal", 82, linePoint + 7);
  doc.text("Geslacht, Cultivar", 84, linePoint + 7);
  doc.text("Maat", 114, linePoint + 7);
  doc.text("Klasse", 129, linePoint + 7);
  doc.text("AM status\npartij", 140, linePoint + 3.5);
  doc.text("Certificaat", 158, linePoint + 7);
  doc.text("Partij", 173.5, linePoint + 7);
  doc.text("Koop\novereenkomst", 187.5, linePoint + 3.5);
  doc.setFont("helvetica");
  doc.setFontSize(9);

  return doc;
};

const renderFustLinesHeader = (doc: jsPDF, linePoint) => {
  doc.setFontSize(8);
  doc.line(11, linePoint + 5, 195, linePoint + 5);
  doc.line(11, linePoint + 13, 195, linePoint + 13);
  doc.setFont("helvetica", "bolditalic");
  doc = alignTextRight(doc, "Totaal", 23, linePoint + 8.5);
  doc = alignTextRight(doc, "fust", 23, linePoint + 11.5);
  doc.text("Type fust", 25, linePoint + 11.5);
  doc.text("Soort fust", 42, linePoint + 11.5);
  doc.text("Overnemen", 87, linePoint + 11.5);
  doc = alignTextRight(doc, "Prijs per", 127, linePoint + 8.5);
  doc = alignTextRight(doc, "fust", 127, linePoint + 11.5);
  doc = alignTextRight(doc, "Prijs Totaal", 151, linePoint + 11.5);
  doc.text("Opmerkingen", 154, linePoint + 11.5);
  doc.setFont("helvetica");
  doc.setFontSize(9);

  return doc;
};

const renderExtraCostsHeader = (doc: jsPDF, linePoint) => {
  doc.setFontSize(8);
  doc.setFont("helvetica", "bolditalic");
  doc.text("Artikel", 11, linePoint + 6);
  doc.text("Omschrijving", 52, linePoint + 6);
  doc = alignTextRight(doc, "Bedrag", 123, linePoint + 6);
  doc.text("Vrije tekst", 125, linePoint + 6);
  doc.setFont("helvetica");
  doc.setFontSize(9);

  return doc;
};

const renderDeliveryNoteFooter = (doc: jsPDF, certificates) => {
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  // Set page height (for reference)
  const pageHeight = doc.internal.pageSize.height;
  let footerText = ``;
  for (let idx = 0; idx < certificates?.length; idx++) {
    const certificate = certificates[idx];
    footerText += `${
      certificate.CertificationOrganization
    } registratienummer: ${certificate.RegistrationNumber}, zie ${
      certificate.CertificationOrganization
    } website voor actuele status certificaten.${
      certificates?.length > 1 ? "\n" : ""
    }`;
  }
  doc.text(footerText, 10, pageHeight - 10);
};

export const generateDeliveryPdf = (
  showCertificates,
  deliveryId,
  deliveryNote,
  seller,
  supplier?
) => {
  let tempLines: any[] = [];
  let addLines = 0;
  const pageNumberPosition: number[] = [];
  let certificates: any = [];
  if (showCertificates) {
    certificates = supplier?.Certificates?.length
      ? supplier.Certificates?.slice(0, 2)
      : seller?.Certificates?.slice(0, 2);
  }

  let doc = new jsPDF();
  doc.setLineWidth(0.1);

  let header = renderPdfHeader(
    showCertificates,
    doc,
    deliveryId,
    deliveryNote,
    seller,
    supplier
  );
  doc = header.doc;

  let linePoint = deliveryNote.logo
    ? header.linePoint + 26
    : header.linePoint + 40;
  pageNumberPosition.push(header.linePoint + 4);

  if (deliveryNote.orderLines && deliveryNote.orderLines.length) {
    doc = renderOrderLinesHeader(doc, linePoint);

    deliveryNote.orderLines.forEach((line, index) => {
      linePoint = index === 0 ? linePoint + 12 : linePoint + 4;
      doc = alignTextRight(
        doc,
        _.get(line, "fust", "").toLocaleString("nl-NL"),
        23,
        linePoint
      );
      doc = alignTextRight(
        doc,
        getFormatted(line.perFust, "number"),
        42,
        linePoint
      );
      doc = alignTextRight(
        doc,
        getFormatted(line.restFust, "number"),
        62,
        linePoint
      );
      doc = alignTextRight(
        doc,
        getFormatted(line.total, "number"),
        82,
        linePoint
      );

      tempLines = doc.splitTextToSize(_.get(line, "cultivar", ""), 30);
      doc.text(tempLines, 84, linePoint);
      addLines = tempLines.length - 1;

      tempLines = doc.splitTextToSize(_.get(line, "maat", ""), 15);
      doc.text(tempLines, 114, linePoint);
      addLines =
        tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;

      doc.text(_.get(line, "class.label", ""), 129, linePoint);
      doc.text(_.get(line, "status.label", ""), 140, linePoint);
      doc.text(_.get(line, "certificate", "") + "", 158, linePoint);

      tempLines = doc.splitTextToSize(_.get(line, "party.label", ""), 14);
      doc.text(tempLines, 173.5, linePoint);
      addLines =
        tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;

      doc.text(_.get(line, "orderNummer.label", ""), 187.5, linePoint);

      if (addLines > 0) {
        linePoint = linePoint + 4 * addLines;
      }

      tempLines = doc.splitTextToSize(line.comment || "", 180);
      doc.text(tempLines, 11, linePoint + 4);
      linePoint = linePoint + 4 * tempLines.length;

      if (certificates?.length) {
        renderDeliveryNoteFooter(doc, certificates);
      }

      doc.setFontSize(10);

      // Adds new page
      if (linePoint > 220) {
        doc.addPage();
        header = renderPdfHeader(
          showCertificates,
          doc,
          deliveryId,
          deliveryNote,
          seller,
          supplier
        );
        doc = header.doc;

        linePoint = deliveryNote.logo
          ? header.linePoint + 26
          : header.linePoint + 40;
        pageNumberPosition.push(header.linePoint + 4);
        if (deliveryNote.orderLines.length - 1 !== index) {
          doc = renderOrderLinesHeader(doc, linePoint);
        }
        linePoint = linePoint + 8;

        if (certificates?.length) {
          renderDeliveryNoteFooter(doc, certificates);
        }
      }
    });
  }

  // Adds new page
  if (linePoint > 220) {
    doc.addPage();
    header = renderPdfHeader(
      showCertificates,
      doc,
      deliveryId,
      deliveryNote,
      seller,
      supplier
    );
    doc = header.doc;
    linePoint = header.linePoint + 18;
    pageNumberPosition.push(header.linePoint + 4);

    if (certificates?.length) {
      renderDeliveryNoteFooter(doc, certificates);
    }
  }

  if (deliveryNote.fustLines && deliveryNote.fustLines.length) {
    doc = renderFustLinesHeader(doc, linePoint);

    deliveryNote.fustLines.forEach((line, index) => {
      linePoint = index === 0 ? linePoint + 16 : linePoint + 4;
      doc = alignTextRight(
        doc,
        _.get(line, "fust", "").toLocaleString("nl-NL"),
        23,
        linePoint
      );
      doc.text(_.get(line, "type.label", ""), 25, linePoint);

      tempLines = doc.splitTextToSize(_.get(line, "kind.label", ""), 45);
      doc.text(tempLines, 42, linePoint);
      addLines = tempLines.length - 1;

      doc.text(_.get(line, "buyContainer.label", ""), 87, linePoint);
      doc = alignTextRight(
        doc,
        getFormatted(line.price, "currency"),
        127,
        linePoint
      );
      doc = alignTextRight(
        doc,
        getFormatted(line.total, "currency"),
        151,
        linePoint
      );

      tempLines = doc.splitTextToSize(line.comment || "", 41);
      doc.text(tempLines, 154, linePoint);
      addLines =
        tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;

      if (addLines > 0) {
        linePoint = linePoint + 4 * addLines;
      }
      // Adds new page
      if (linePoint > 220) {
        doc.addPage();
        header = renderPdfHeader(
          showCertificates,
          doc,
          deliveryId,
          deliveryNote,
          seller,
          supplier
        );
        doc = header.doc;

        linePoint = deliveryNote.logo
          ? header.linePoint + 22
          : header.linePoint + 36;
        pageNumberPosition.push(header.linePoint + 4);
        if (deliveryNote.fustLines.length - 1 !== index) {
          doc = renderFustLinesHeader(doc, linePoint);
        }
        linePoint = linePoint + 12;

        if (certificates?.length) {
          renderDeliveryNoteFooter(doc, certificates);
        }
      }
    });
  }

  // Adds new page
  if (linePoint > 220) {
    doc.addPage();
    header = renderPdfHeader(
      showCertificates,
      doc,
      deliveryId,
      deliveryNote,
      seller,
      supplier
    );
    doc = header.doc;
    linePoint = header.linePoint + 18;
    pageNumberPosition.push(header.linePoint + 4);

    if (certificates?.length) {
      renderDeliveryNoteFooter(doc, certificates);
    }
  }

  if (deliveryNote.extraCostLines && deliveryNote.extraCostLines.length) {
    doc = renderExtraCostsHeader(doc, linePoint);

    deliveryNote.extraCostLines.forEach((line, index) => {
      linePoint = index === 0 ? linePoint + 10 : linePoint + 4;
      doc.text(_.get(line, "article.label", ""), 11, linePoint);

      tempLines = doc.splitTextToSize(_.get(line, "description", ""), 45);
      doc.text(tempLines, 52, linePoint);
      addLines = tempLines.length - 1;

      doc = alignTextRight(
        doc,
        getFormatted(line.amount, "currency"),
        123,
        linePoint
      );

      tempLines = doc.splitTextToSize(line.comment || "", 70);
      doc.text(tempLines, 125, linePoint);
      addLines =
        tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;

      if (addLines > 0) {
        linePoint = linePoint + 4 * addLines;
      }

      // Adds new page
      if (linePoint > 220) {
        doc.addPage();
        header = renderPdfHeader(
          showCertificates,
          doc,
          deliveryId,
          deliveryNote,
          seller,
          supplier
        );
        doc = header.doc;

        linePoint = deliveryNote.logo
          ? header.linePoint + 22
          : header.linePoint + 36;
        pageNumberPosition.push(header.linePoint + 4);
        if (deliveryNote.extraCostLines.length - 1 !== index) {
          doc = renderExtraCostsHeader(doc, linePoint);
        }
        linePoint = linePoint + 6;

        if (certificates?.length) {
          renderDeliveryNoteFooter(doc, certificates);
        }
      }
    });
  }
  doc.setFontSize(9);

  // Adds new page
  if (linePoint > 220) {
    doc.addPage();
    header = renderPdfHeader(
      showCertificates,
      doc,
      deliveryId,
      deliveryNote,
      seller,
      supplier
    );
    doc = header.doc;
    pageNumberPosition.push(header.linePoint + 4);

    if (certificates?.length) {
      renderDeliveryNoteFooter(doc, certificates);
    }
  }
  linePoint = 235;

  // The block at the bottom

  doc.line(11, linePoint - 6.5, 195, linePoint - 6.5);

  if (deliveryNote.comment) {
    tempLines = doc.splitTextToSize(deliveryNote.comment || "", 184);
    doc.text(tempLines, 11, linePoint);
    linePoint = linePoint + (tempLines.length = 1) * 4;
  }

  doc.text("Handtekening", 11, linePoint + 19);
  doc.line(11, linePoint + 9.5, 200, linePoint + 9.5);
  doc.line(11, linePoint + 27, 200, linePoint + 27);

  if (supplier) {
    doc.text(
      "Deze leverantie is verzorgd door voorkeurkweker:",
      11,
      linePoint + 31
    );
    doc.text(_.get(supplier, "Name", ""), 11, linePoint + 37);
    doc.text(
      _.get(supplier, "PrimaryAddress.Address1", ""),
      11,
      linePoint + 41
    );
    doc.text(
      _.get(supplier, "PrimaryAddress.ZipCode", "") +
        " " +
        _.get(supplier, "PrimaryAddress.City", ""),
      11,
      linePoint + 45
    );
    doc.text(
      _.get(supplier, "PrimaryAddress.Country.Description", ""),
      11,
      linePoint + 49
    );

    doc.text(
      `Fytosanitair nummer: ${supplier.FytosanitairNumber || "-"}`,
      11,
      linePoint + 53
    );
    doc.text(
      `Tel: ${_.get(supplier, "OfficeNumber", "")}`,
      100,
      linePoint + 41
    );
    doc.text(`Fax: ${_.get(supplier, "FaxNumber", "")}`, 100, linePoint + 45);
    doc.text(
      `E-mail: ${_.get(supplier, "MailAddress", "")}`,
      100,
      linePoint + 49
    );
  }

  // Writes page number
  for (let i = 0; i < pageNumberPosition.length; i++) {
    doc.setPage(i + 1);
    doc.text(
      `${i + 1}/${pageNumberPosition.length}`,
      62,
      pageNumberPosition[i]
    );
  }
  return doc.output("dataurlstring");
};

function getObjectsWithMultipleValues(arr, threshold = 1) {
  const result = [] as any;
  for (const obj of arr) {
    let count = 0;
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (obj[prop] !== "") {
          count++;
        }
        if (count > threshold) {
          result.push(obj);
          break;
        }
      }
    }
  }
  return result;
}

///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
// ************************* VORJ PDF ************************** //
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
export const generateVorrjPdf = (statementLine) => {
  let tempLines: any[] = [];
  let addLines = 0;
  const pageNumberPosition: number[] = [];

  const doc = new jsPDF();
  doc.setLineWidth(0.1);

  let linePoint = 35;

  const logo = document.getElementById("cnb-logo") as HTMLImageElement;
  doc.addImage(logo, "JPEG", 15, 5, 40, 18);

  const licensorDetailsResponse = renderLicensorLicenseeInformation(
    doc,
    statementLine,
    linePoint,
    tempLines,
    addLines
  );
  linePoint = licensorDetailsResponse.linePoint;
  tempLines = licensorDetailsResponse.tempLines;
  addLines = licensorDetailsResponse.addLines;

  if (
    statementLine.cultivationLocations &&
    statementLine.cultivationLocations.length &&
    statementLine.cultivationLocations[0].RR
  ) {
    renderCultivationLocationsHeader(doc, linePoint);
    doc.setFont("helvetica", "normal");
    statementLine.cultivationLocations.forEach((line, index) => {
      if (Object.values(line).every((value) => !!value)) {
        linePoint = index === 0 ? linePoint + 12 : linePoint + 4;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 72, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 80);
        doc.text(tempLines, 115, linePoint);
        addLines = tempLines.length - 1;

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
        linePoint += 2;
      }
    });
  } else {
    linePoint += 4;
    doc.text("Geen opgave voor dit oogstjaar.", 23, linePoint);
  }

  // add space
  if (
    statementLine.cultivationLocations &&
    statementLine.cultivationLocations.length &&
    statementLine.cultivationLocations[0].RR &&
    statementLine.contractorDetail
  ) {
    linePoint = linePoint + 10;
    doc.setFont("helvetica", "bolditalic");
    doc.text(
      "Indien uw bollen op contract worden geteeld s.v.p vemelding naam en mobiel telefoonnummer van contractnemer",
      23,
      linePoint
    );
    linePoint = linePoint + 6;
    doc.setFont("helvetica", "normal");
    tempLines = doc.splitTextToSize(
      _.get(statementLine, "contractorDetail", ""),
      150
    );
    doc.text(tempLines, 23, linePoint);
    linePoint += 10;
  } else {
    linePoint += 15;
  }

  // print planting materials
  if (
    statementLine.plantingMaterial &&
    statementLine.plantingMaterial.length &&
    statementLine.plantingMaterial[0].buyerCompanyName
  ) {
    const response = renderPlantingMaterialHeader(doc, linePoint);
    linePoint = response.linePoint;
    doc.setFont("helvetica", "normal");
    statementLine.plantingMaterial.forEach((line, index) => {
      linePoint = index === 0 ? linePoint + 12 : linePoint + 4;
      tempLines = doc.splitTextToSize(_.get(line, "buyerCompanyName", ""), 27);
      doc.text(tempLines, 23, linePoint);
      addLines = tempLines.length - 1;

      tempLines = doc.splitTextToSize(_.get(line, "address", ""), 40);
      doc.text(tempLines, 50, linePoint);
      addLines =
        tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;
      doc.text(
        _.get(line, "residence", "").toLocaleString("nl-NL"),
        92,
        linePoint
      );
      doc.text(
        _.get(line, "numberOfPortions", "").toLocaleString("nl-NL"),
        120,
        linePoint
      );
      doc.text(
        _.get(line, "quantity", "").toLocaleString("nl-NL"),
        135,
        linePoint
      );
      doc.text(
        _.get(line, "orderNumber", "").toLocaleString("nl-NL"),
        158,
        linePoint
      );
      doc.text(_.get(line, "IVB", "").toLocaleString("nl-NL"), 178, linePoint);

      if (addLines > 0) {
        linePoint = linePoint + 4 * addLines;
      }
      doc.line(15, linePoint + 2, 200, linePoint + 2);
      linePoint += 2;
    });
  } else {
    linePoint += 8;
    doc.text("Geen plantgoed verkocht.", 23, linePoint);
  }

  linePoint += 20;
  doc.setFont("helvetica", "bold");
  doc.text("Datum van opgave ", 23, linePoint);
  doc.text(
    moment(new Date(_.get(statementLine, "date", ""))).format("DD-MM-YYYY"),
    65,
    linePoint
  );

  return doc.output("dataurlstring");
};

///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
// ************************* ZANT PDF ************************** //
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
export const generateZantPdf = (statementLine) => {
  let tempLines: any[] = [];
  let addLines = 0;
  const pageNumberPosition: number[] = [];
  const doc = new jsPDF();
  doc.setLineWidth(0.1);
  let linePoint = 35;
  const logo = document.getElementById("cnb-logo") as HTMLImageElement;
  doc.addImage(logo, "JPEG", 15, 5, 40, 18);

  const headerResponse = renderLicensorLicenseeInformation(
    doc,
    statementLine,
    linePoint,
    tempLines,
    addLines
  );
  linePoint = headerResponse.linePoint;
  tempLines = headerResponse.tempLines;
  addLines = headerResponse.addLines;
  if (!statementLine.noStatementLine) {
    // cultivation locations (1)
    const cultivationLocationsWithMultipleValues = getObjectsWithMultipleValues(
      statementLine.cultivationLocations
    );
    if (cultivationLocationsWithMultipleValues.length > 0) {
      linePoint += 10;
      const headerRes = renderCultivationLocationsHeaderZant(
        doc,
        linePoint,
        tempLines,
        addLines
      );
      tempLines = headerRes.tempLines;
      linePoint = headerRes.linePoint;
      doc.setFont("helvetica", "normal");
      cultivationLocationsWithMultipleValues.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 82, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 80);
        doc.text(tempLines, 115, linePoint);
        addLines = tempLines.length - 1;

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
        linePoint += 2;
      });
    }

    // T1 Measuremenst (2)
    const t1MeasurmentsWithMultipleValues = getObjectsWithMultipleValues(
      statementLine.t1Measurements
    );
    if (t1MeasurmentsWithMultipleValues.length > 0) {
      linePoint += 10;
      const headerRes = renderT1MeasurementsHeaderZant(
        doc,
        linePoint,
        tempLines,
        addLines
      );
      tempLines = headerRes.tempLines;
      linePoint = headerRes.linePoint;
      doc.setFont("helvetica", "normal");
      t1MeasurmentsWithMultipleValues.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 82, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 80);
        doc.text(tempLines, 115, linePoint);
        addLines = tempLines.length - 1;

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
        linePoint += 2;
      });
    }

    // surface materials (3)
    const surfaceMaterialsWithMultipleValues = getObjectsWithMultipleValues(
      statementLine.surfaceMaterials
    );
    if (surfaceMaterialsWithMultipleValues.length > 0) {
      linePoint += 10;
      const res = renderPartOnePlantingLocationsHeader(
        doc,
        linePoint,
        tempLines,
        addLines
      );
      tempLines = res.tempLines;
      linePoint = res.linePoint;
      doc.setFont("helvetica", "normal");
      surfaceMaterialsWithMultipleValues.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 82, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 80);
        doc.text(tempLines, 115, linePoint);
        addLines = tempLines.length - 1;

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
        linePoint += 2;
      });
    }

    // add space
    if (
      statementLine.cultivationLocations &&
      statementLine.cultivationLocations.length &&
      statementLine.contractorDetail
    ) {
      linePoint = linePoint + 10;
      doc.setFont("helvetica", "bolditalic");
      doc.text(
        "Indien uw bollen op contract worden geteeld s.v.p vemelding naam en mobiel telefoonnummer van contractnemer",
        23,
        linePoint
      );
      linePoint = linePoint + 6;
      doc.setFont("helvetica", "normal");
      tempLines = doc.splitTextToSize(
        _.get(statementLine, "contractorDetail", ""),
        150
      );
      doc.text(tempLines, 23, linePoint);
      linePoint += 10;
    } else {
      linePoint += 10;
    }
  } else {
    linePoint += 4;
    doc.text("Geen opgave voor dit oogstjaar.", 23, linePoint);
  }

  // print planting materials
  const plantingMaterialWithMultipleValues = getObjectsWithMultipleValues(
    statementLine.plantingMaterial
  );
  if (
    plantingMaterialWithMultipleValues &&
    plantingMaterialWithMultipleValues.length > 0
  ) {
    linePoint += 10;
    doc.text("Plantgoed verkocht aan :", 23, linePoint);
    linePoint += 4;
    const response = renderPlantingMaterialHeader(doc, linePoint);
    linePoint = response.linePoint;
    doc.setFont("helvetica", "normal");
    plantingMaterialWithMultipleValues.forEach((line, index) => {
      linePoint = index === 0 ? linePoint + 12 : linePoint + 4;
      tempLines = doc.splitTextToSize(_.get(line, "buyerCompanyName", ""), 27);
      doc.text(tempLines, 23, linePoint);
      addLines = tempLines.length - 1;

      tempLines = doc.splitTextToSize(_.get(line, "address", ""), 40);
      doc.text(tempLines, 50, linePoint);
      addLines =
        tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;
      doc.text(
        _.get(line, "residence", "").toLocaleString("nl-NL"),
        92,
        linePoint
      );
      doc.text(
        _.get(line, "numberOfPortions", "").toLocaleString("nl-NL"),
        120,
        linePoint
      );
      doc.text(
        _.get(line, "quantity", "").toLocaleString("nl-NL"),
        135,
        linePoint
      );
      doc.text(
        _.get(line, "orderNumber", "").toLocaleString("nl-NL"),
        158,
        linePoint
      );
      doc.text(_.get(line, "IVB", "").toLocaleString("nl-NL"), 178, linePoint);

      if (addLines > 0) {
        linePoint = linePoint + 4 * addLines;
      }
      doc.line(15, linePoint + 2, 200, linePoint + 2);
      linePoint += 2;
    });
  } else {
    linePoint += 8;
    doc.text("Geen plantgoed verkocht.", 23, linePoint);
  }

  linePoint += 20;
  doc.setFont("helvetica", "bold");
  doc.text("Datum van opgave ", 23, linePoint);
  doc.text(
    moment(new Date(_.get(statementLine, "date", ""))).format("DD-MM-YYYY"),
    65,
    linePoint
  );

  return doc.output("dataurlstring");
};

///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
// ************************* LELIE PDF ************************** //
//////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
export const generateLeliePdf = (statementLine) => {
  let tempLines: any[] = [];
  let addLines = 0;
  const pageNumberPosition: number[] = [];
  const { leverbaar, schub } = statementLine;
  const doc = new jsPDF();
  doc.setLineWidth(0.1);
  let linePoint = 35;

  const logo = document.getElementById("cnb-logo") as HTMLImageElement;
  doc.addImage(logo, "JPEG", 15, 5, 40, 18);

  const headerResponse = renderLicensorLicenseeInformation(
    doc,
    statementLine,
    linePoint,
    tempLines,
    addLines
  );
  linePoint = headerResponse.linePoint;
  tempLines = headerResponse.tempLines;
  addLines = headerResponse.addLines;

  if (!statementLine.noStatementLine) {
    if (
      !!leverbaar.leverbaar_1[0].RR ||
      !!leverbaar.leverbaar_2e[0].RR ||
      !!leverbaar.leverbaar_1e[0].RR
    ) {
      linePoint += 10;
      const updatedLines = renderSchubHeader(
        doc,
        linePoint,
        tempLines,
        addLines
      );
      linePoint = updatedLines.linePoint;
      tempLines = updatedLines.tempLines;
      addLines = updatedLines.addLines;
      doc.setFont("helvetica", "normal");
    }
    const leverbaar_1MultipleValues = getObjectsWithMultipleValues(
      statementLine.leverbaar.leverbaar_1,
      2
    );
    if (leverbaar_1MultipleValues.length > 0) {
      statementLine.leverbaar.leverbaar_1.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(`${_.get(line, "harvestYear", "")}`, 53, linePoint);
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 73, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 65);
        doc.text(tempLines, 90, linePoint);
        addLines = tempLines.length - 1;
        doc.text(
          _.get(line, "x_cord", "").toLocaleString("nl-NL"),
          158,
          linePoint
        );
        doc.text(
          _.get(line, "y_cord", "").toLocaleString("nl-NL"),
          178,
          linePoint
        );

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
        //
      });
    }

    const leverbaar_2eMultipleValues = getObjectsWithMultipleValues(
      statementLine.leverbaar.leverbaar_2e,
      2
    );
    if (leverbaar_2eMultipleValues.length > 0) {
      leverbaar_2eMultipleValues.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(`${_.get(line, "harvestYear", "")}`, 53, linePoint);
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 73, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 65);
        doc.text(tempLines, 90, linePoint);
        addLines = tempLines.length - 1;
        doc.text(
          _.get(line, "x_cord", "").toLocaleString("nl-NL"),
          158,
          linePoint
        );
        doc.text(
          _.get(line, "y_cord", "").toLocaleString("nl-NL"),
          178,
          linePoint
        );

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
      });
    }

    const leverbaar_1eMultipleValues = getObjectsWithMultipleValues(
      statementLine.leverbaar.leverbaar_1e,
      2
    );
    if (leverbaar_1eMultipleValues.length > 0) {
      leverbaar_1eMultipleValues.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(`${_.get(line, "harvestYear", "")}`, 53, linePoint);
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 73, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 65);
        doc.text(tempLines, 90, linePoint);
        addLines = tempLines.length - 1;
        doc.text(
          _.get(line, "x_cord", "").toLocaleString("nl-NL"),
          158,
          linePoint
        );
        doc.text(
          _.get(line, "y_cord", "").toLocaleString("nl-NL"),
          178,
          linePoint
        );

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
      });
    }

    if (
      !!schub.schub_1[0].RR ||
      !!schub.schub_2e[0].RR ||
      !!schub.schub_1e[0].RR
    ) {
      linePoint += 10;
      const updatedLines = renderSchubHeader(
        doc,
        linePoint,
        tempLines,
        addLines
      );
      tempLines = updatedLines.tempLines;
      linePoint = updatedLines.linePoint;
      addLines = updatedLines.addLines;
      doc.setFont("helvetica", "normal");
    }

    const schub_1MultipleValues = getObjectsWithMultipleValues(
      statementLine.schub.schub_1,
      2
    );
    if (schub_1MultipleValues.length > 0) {
      schub_1MultipleValues.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(`${_.get(line, "harvestYear", "")}`, 53, linePoint);
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 73, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 65);
        doc.text(tempLines, 90, linePoint);
        addLines = tempLines.length - 1;
        doc.text(
          _.get(line, "x_cord", "").toLocaleString("nl-NL"),
          158,
          linePoint
        );
        doc.text(
          _.get(line, "y_cord", "").toLocaleString("nl-NL"),
          178,
          linePoint
        );

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        // Adds new page
        doc.line(15, linePoint + 2, 200, linePoint + 2);
        if (linePoint > 240) {
          doc.addPage();
          const header = renderAreaalPdfHeader(doc);
          linePoint = header.linePoint + 6;
        }
      });

      // Adds new page
      if (linePoint > 240) {
        doc.addPage();
        const header = renderAreaalPdfHeader(doc);
        linePoint = header.linePoint + 6;
      }
    }

    const schub_2eMultipleValues = getObjectsWithMultipleValues(
      statementLine.schub.schub_2e,
      2
    );
    if (schub_2eMultipleValues.length > 0) {
      schub_2eMultipleValues.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(`${_.get(line, "harvestYear", "")}`, 53, linePoint);
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 73, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 65);
        doc.text(tempLines, 90, linePoint);
        addLines = tempLines.length - 1;
        doc.text(
          _.get(line, "x_cord", "").toLocaleString("nl-NL"),
          158,
          linePoint
        );
        doc.text(
          _.get(line, "y_cord", "").toLocaleString("nl-NL"),
          178,
          linePoint
        );

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
        // Adds new page
        if (linePoint > 240) {
          doc.addPage();
          const header = renderAreaalPdfHeader(doc);
          // pageNumberPosition.push(header.linePoint + 4);
          linePoint = header.linePoint + 6;
        }
      });

      // Adds new page
      if (linePoint > 240) {
        doc.addPage();
        const header = renderAreaalPdfHeader(doc);
        linePoint = header.linePoint + 6;
      }
    }

    const schub_1eMultipleValues = getObjectsWithMultipleValues(
      statementLine.schub.schub_1e,
      2
    );
    if (schub_1eMultipleValues.length > 0) {
      statementLine.schub.schub_1e.forEach((line, index) => {
        linePoint = index === 0 ? linePoint + 10 : linePoint + 6;
        doc.text(
          _.get(line, "area", "").toLocaleString("nl-NL"),
          23,
          linePoint
        );
        doc.text(`${_.get(line, "harvestYear", "")}`, 53, linePoint);
        doc.text(_.get(line, "RR", "").toLocaleString("nl-NL"), 73, linePoint);
        tempLines = doc.splitTextToSize(_.get(line, "description", ""), 65);
        doc.text(tempLines, 90, linePoint);
        addLines = tempLines.length - 1;
        doc.text(
          _.get(line, "x_cord", "").toLocaleString("nl-NL"),
          158,
          linePoint
        );
        doc.text(
          _.get(line, "y_cord", "").toLocaleString("nl-NL"),
          178,
          linePoint
        );

        if (addLines > 0) {
          linePoint = linePoint + 4 * addLines;
        }
        doc.line(15, linePoint + 2, 200, linePoint + 2);
        // Adds new page
        if (linePoint > 240) {
          doc.addPage();
          const header = renderAreaalPdfHeader(doc);
          pageNumberPosition.push(header.linePoint + 4);
          linePoint = header.linePoint + 6;
        }
      });
      // Adds new page
      if (linePoint > 240) {
        doc.addPage();
        const header = renderAreaalPdfHeader(doc);
        linePoint = header.linePoint + 6;
      }
    }

    // // print planting tissue
    if (
      (statementLine.plantTissue &&
        statementLine.plantTissue[0].weefselkweek.wRR) ||
      statementLine.plantTissue[0].laboratorium.lRR
    ) {
      // Define an array to store the table data
      const data = [] as any;
      const columns = [
        { header: "Oppervlakte", dataKey: "area" },
        { header: "Oogstjaar", dataKey: "harvestYear" },
        { header: "RR", dataKey: "iRR" },
        { header: "Kas / Naam laboratorium", dataKey: "greenHouse" },
        { header: "X-coördinaat", dataKey: "xCordinate" },
        { header: "Y-coördinaat", dataKey: "yCordinate" },
      ];
      statementLine.plantTissue.forEach((obj) => {
        const laboratorium = obj.laboratorium;
        const weefselkweek = obj.weefselkweek;
        // Add Weefselkweek data to the table
        if (statementLine.plantTissue[0].weefselkweek.wRR) {
          data.push({
            area: weefselkweek.wArea,
            harvestYear: weefselkweek.wHarvestYear,
            iRR: weefselkweek.wRR,
            greenHouse: weefselkweek.wGreenHouse,
            xCordinate: weefselkweek.wX_cord,
            yCordinate: weefselkweek.wY_cord,
          });
        }
        if (statementLine.plantTissue[0].laboratorium.lRR) {
          // Add Laboratorium data to the table
          data.push({
            area: laboratorium.lArea,
            harvestYear: laboratorium.lHarvestYear,
            iRR: laboratorium.lRR,
            greenHouse: laboratorium.lGreenHouse,
            xCordinate: laboratorium.lX_cord,
            yCordinate: laboratorium.lY_cord,
          });
        }

        data.push({});

        if (linePoint > 240) {
          doc.addPage();
          const header = renderAreaalPdfHeader(doc);
          linePoint = header.linePoint + 6;
        }
      });

      autoTable(doc, {
        body: data,
        columns,
        startY: (linePoint += 10),
        margin: { top: 10, left: 14, right: 10, bottom: 0 },
        styles: {
          fontSize: 8,
          cellPadding: 0,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          fontStyle: "bolditalic",
          lineColor: 0,
          cellPadding: { top: 3, right: 0, bottom: 3, left: 9 },
          lineWidth: {
            bottom: 0.28,
            top: 0.2,
          },
        },
        bodyStyles: {
          fillColor: [255, 255, 255],
          cellPadding: { top: 2, right: 0, bottom: 2, left: 9 },
          fontStyle: "normal",
          lineColor: 0,
          lineWidth: {
            top: 0.15,
          },
        },
        theme: "plain",
        didDrawPage: (data: any) => (linePoint = data.cursor.y),
      });

      if (linePoint > 240) {
        doc.addPage();
        const header = renderAreaalPdfHeader(doc);
        linePoint = header.linePoint + 6;
      }
    }
  } else {
    linePoint += 4;
    doc.text("Geen opgave voor dit oogstjaar.", 23, linePoint);
  }

  const plantingMaterialWithMultipleValues = getObjectsWithMultipleValues(
    statementLine.plantingMaterial
  );
  if (
    plantingMaterialWithMultipleValues &&
    plantingMaterialWithMultipleValues.length > 0
  ) {
    linePoint += 10;
    doc.text("Plantgoed verkocht aan :", 23, linePoint);
    linePoint += 4;
    // print planting materials
    const plantingHeaderResponse = renderPlantingMaterialHeader(doc, linePoint);
    linePoint = plantingHeaderResponse.linePoint;
    doc.setFont("helvetica", "normal");
    plantingMaterialWithMultipleValues.forEach((line, index) => {
      linePoint = index === 0 ? linePoint + 12 : linePoint + 4;
      tempLines = doc.splitTextToSize(_.get(line, "buyerCompanyName", ""), 27);
      doc.text(tempLines, 23, linePoint);
      addLines = tempLines.length - 1;

      tempLines = doc.splitTextToSize(_.get(line, "address", ""), 37);
      doc.text(tempLines, 53, linePoint);
      addLines =
        tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;
      doc.text(
        _.get(line, "residence", "").toLocaleString("nl-NL"),
        92,
        linePoint
      );
      doc.text(
        _.get(line, "numberOfPortions", "").toLocaleString("nl-NL"),
        120,
        linePoint
      );
      doc.text(
        _.get(line, "quantity", "").toLocaleString("nl-NL"),
        135,
        linePoint
      );
      doc.text(
        _.get(line, "orderNumber", "").toLocaleString("nl-NL"),
        158,
        linePoint
      );
      doc.text(_.get(line, "IVB", "").toLocaleString("nl-NL"), 178, linePoint);

      if (addLines > 0) {
        linePoint = linePoint + 4 * addLines;
      }
      // Adds new page
      if (linePoint > 240) {
        doc.addPage();
        const header = renderAreaalPdfHeader(doc);
        linePoint = header.linePoint + 6;
      }
      doc.line(15, linePoint + 2, 200, linePoint + 2);
      linePoint += 2;
    });
    // Adds new page
    if (linePoint > 240) {
      doc.addPage();
      const header = renderAreaalPdfHeader(doc);
      linePoint = header.linePoint + 6;
    }
  } else {
    linePoint += 5;
    doc.text("Geen plantgoed verkocht.", 23, linePoint);
  }

  linePoint += 20;
  doc.setFont("helvetica", "bold");
  doc.text("Datum van opgave ", 23, linePoint);
  doc.text(
    moment(new Date(_.get(statementLine, "date", ""))).format("DD-MM-YYYY"),
    65,
    linePoint
  );

  return doc.output("dataurlstring");
};

const renderSchubHeader = (doc: jsPDF, linePoint, tempLines, addLines) => {
  doc.setFontSize(8);
  doc.line(15, linePoint, 200, linePoint);
  doc.line(15, linePoint + 12, 200, linePoint + 12);
  doc.setFont("helvetica", "bolditalic");
  doc.text("Oppervlakte", 23, linePoint + 3.5);
  doc.text("Oogstjaar", 53, linePoint + 3.5);
  doc.text("RR", 73, linePoint + 3.5);
  tempLines = doc.splitTextToSize(
    "Teeltlocaties, plaats, contactpersoon, evt tel. nr (tevens invullen indien areaal nog niet bekend is)",
    65
  );
  doc.text(tempLines, 90, linePoint + 3.5);
  addLines = tempLines.length - 1;
  doc.text("X-coördinaat", 158, linePoint + 3.5);
  doc.text("Y-coördinaat", 178, linePoint + 3.5);
  doc.setFont("helvetica");
  doc.setFontSize(8);
  if (addLines > 0) {
    linePoint = linePoint + 4 * addLines;
  }

  return { doc, tempLines, linePoint, addLines };
};

const renderKasLabHeader = (doc: jsPDF, linePoint, tempLines, addLines) => {
  doc.setFontSize(8);
  doc.line(15, linePoint, 200, linePoint);
  doc.line(15, linePoint + 6, 200, linePoint + 6);
  doc.setFont("helvetica", "bolditalic");
  doc.text("Oppervlakte", 23, linePoint + 3.5);
  doc.text("Oogstjaar", 53, linePoint + 3.5);
  doc.text("RR", 73, linePoint + 3.5);
  tempLines = doc.splitTextToSize("Kas / Naam laboratorium ", 65);
  doc.text(tempLines, 90, linePoint + 3.5);
  addLines = tempLines.length - 1;
  doc.text("X-coördinaat", 158, linePoint + 3.5);
  doc.text("Y-coördinaat", 178, linePoint + 3.5);
  doc.setFont("helvetica");
  doc.setFontSize(8);
  linePoint += 2;

  return { doc, tempLines, linePoint, addLines };
};

const renderCultivationLocationsHeader = (doc: jsPDF, linePoint) => {
  doc.setFontSize(8);
  doc.line(15, linePoint, 200, linePoint);
  doc.line(15, linePoint + 6, 200, linePoint + 6);
  doc.setFont("helvetica", "bolditalic");
  doc.text("Oppervlakte", 23, linePoint + 3.5);
  doc.text("RR", 72, linePoint + 3.5);
  doc.text(
    "Teeltlocaties-Groeiplaatsen: Adres- (Woon)plaats",
    115,
    linePoint + 3.5
  );
  doc.setFont("helvetica");
  doc.setFontSize(8);

  return doc;
};

const renderCultivationLocationsHeaderZant = (
  doc: jsPDF,
  linePoint,
  tempLines,
  addLines
) => {
  doc.setFontSize(8);
  doc.line(15, linePoint, 200, linePoint);
  doc.setFont("helvetica", "bolditalic");
  tempLines = doc.splitTextToSize(
    "Oppervlakte uitgangsmateriaal ten behoeve van leverbare knollen teelt",
    50
  );
  doc.text(tempLines, 23, linePoint + 3.5);
  addLines = tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;
  if (addLines > 0) {
    linePoint = linePoint + 4 * addLines;
  }
  doc.line(15, linePoint + 4, 200, linePoint + 4);
  doc.text("RR", 82, linePoint + 3.5);
  doc.text(
    "Teeltlocaties-Groeiplaatsen: Adres- (Woon)plaats",
    115,
    linePoint + 3.5
  );
  doc.setFont("helvetica");
  doc.setFontSize(8);

  return { doc, linePoint, tempLines, addLines };
};

const renderT1MeasurementsHeaderZant = (
  doc: jsPDF,
  linePoint,
  tempLines,
  addLines
) => {
  doc.setFontSize(8);
  doc.line(15, linePoint, 200, linePoint);
  doc.setFont("helvetica", "bolditalic");
  tempLines = doc.splitTextToSize("Oppervlakte T1", 50);
  doc.text(tempLines, 23, linePoint + 3.5);
  addLines = tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;
  if (addLines > 0) {
    linePoint = linePoint + 4 * addLines;
  }
  doc.line(15, linePoint + 4, 200, linePoint + 4);
  doc.text("RR", 82, linePoint + 3.5);
  doc.text(
    "Teeltlocaties-Groeiplaatsen: Adres- (Woon)plaats",
    115,
    linePoint + 3.5
  );
  doc.setFont("helvetica");
  doc.setFontSize(8);

  return { doc, linePoint, tempLines, addLines };
};

const renderPlantingMaterialHeader = (doc: jsPDF, linePoint) => {
  doc.setFontSize(8);
  doc.line(15, linePoint, 200, linePoint);
  doc.line(15, linePoint + 9, 200, linePoint + 9);
  doc.setFont("helvetica", "bolditalic");
  doc.text("Bedrijfsnaam", 23, linePoint + 3.5);
  doc.text("Koper", 23, linePoint + 7);
  doc.text("Adres", 53, linePoint + 3.5);
  doc.text("Woonplaats", 92, linePoint + 3.5);
  doc.text("Aantal", 120, linePoint + 3.5);
  doc.text("portie(s)", 120, linePoint + 7);
  doc.text("Aantal", 135, linePoint + 3.5);
  doc.text("kg/stuks", 135, linePoint + 7);
  doc.text("Order nrs", 158, linePoint + 3.5);
  doc.text("IVB", 178, linePoint + 3.5);
  doc.setFont("helvetica");
  doc.setFontSize(8);
  linePoint += 2;

  return { doc, linePoint };
};

const renderPartOnePlantingLocationsHeader = (
  doc: jsPDF,
  linePoint,
  tempLines,
  addLines
): { doc: any; tempLines: any[]; linePoint: any } => {
  doc.setFontSize(8);
  doc.line(15, linePoint, 200, linePoint);
  doc.setFont("helvetica", "bolditalic");
  tempLines = doc.splitTextToSize(
    "Oppervlakte uitgangsmateriaal ten behoeve van plantgoed (fijnparteren, 'snipperen', broodmachine, etc)",
    50
  );
  doc.text(tempLines, 23, linePoint + 3.5);
  addLines = tempLines.length - 1 > addLines ? tempLines.length - 1 : addLines;
  if (addLines > 0) {
    linePoint = linePoint + 4 * addLines;
  }
  doc.line(15, linePoint + 4, 200, linePoint + 4);
  doc.text("RR", 82, linePoint + 3.5);
  doc.text(
    "Teeltlocaties-Groeiplaatsen: Adres- (Woon)plaats",
    115,
    linePoint + 3.5
  );
  doc.setFont("helvetica");
  doc.setFontSize(8);

  return { doc, tempLines, linePoint };
};

const renderLicensorLicenseeInformation = (
  doc,
  statementLine,
  linePoint,
  tempLines,
  addLines
): { linePoint: number; tempLines: any; addLines: any } => {
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  // Page Title Section
  doc.text("AREAALOPGAVE", 23, linePoint);
  doc.text(`${_.get(statementLine, "harvestYear", "")}`, 55, linePoint);
  doc.line(15, linePoint + 2, 200, linePoint + 2);

  doc.setFontSize(10);
  doc.text(`${_.get(statementLine, "itemId", "")}`, 115, linePoint);
  doc.text(
    _.get(statementLine, "cultivar", "").toLocaleString("nl-NL"),
    130,
    linePoint
  );

  linePoint += 10;
  doc.setFontSize(8);
  // licencee and licensor details
  doc.setFont("helvetica", "bold");
  doc.text("Licentienemer", 23, linePoint);
  doc.text("Licentiegever", 115, linePoint);

  doc.setFont("helvetica", "normal");
  doc.text(
    _.get(statementLine, "licensee.Name", "").toLocaleString("nl-NL"),
    23,
    linePoint + 4
  );
  doc.text(
    _.get(statementLine, "licensor.Name", "").toLocaleString("nl-NL"),
    115,
    linePoint + 4
  );

  doc.text(
    _.get(statementLine, "licensee.PrimaryAddress.Address1", "").toLocaleString(
      "nl-NL"
    ),
    23,
    linePoint + 8
  );
  doc.text(
    _.get(statementLine, "licensee.PrimaryAddress.ZipCode", "").toLocaleString(
      "nl-NL"
    ),
    23,
    linePoint + 12
  );
  doc.text(
    _.get(statementLine, "licensee.PrimaryAddress.City", "").toLocaleString(
      "nl-NL"
    ),
    36,
    linePoint + 12
  );
  doc.text(
    _.get(statementLine, "licensor.PrimaryAddress.Address1", "").toLocaleString(
      "nl-NL"
    ),
    115,
    linePoint + 8
  );
  doc.text(
    _.get(statementLine, "licensor.PrimaryAddress.ZipCode", "").toLocaleString(
      "nl-NL"
    ),
    115,
    linePoint + 12
  );
  doc.text(
    _.get(statementLine, "licensor.PrimaryAddress.City", "").toLocaleString(
      "nl-NL"
    ),
    128,
    linePoint + 12
  );

  linePoint += 25;

  doc.text("Relatienummer", 23, linePoint);
  doc.text(
    _.get(statementLine, "licensee.Number", "").toLocaleString("nl-NL"),
    50,
    linePoint
  );

  doc.text("Relatienummer", 115, linePoint);
  doc.text(
    _.get(statementLine, "licensor.Number", "").toLocaleString("nl-NL"),
    140,
    linePoint
  );

  doc.text("Telefoon", 23, linePoint + 4);
  doc.text(
    _.get(statementLine, "licensee.MobileNumber", "").toLocaleString("nl-NL"),
    50,
    linePoint + 4
  );

  doc.text("Telefoon", 115, linePoint + 4);
  doc.text(
    _.get(statementLine, "licensor.MobileNumber", "").toLocaleString("nl-NL"),
    140,
    linePoint + 4
  );

  doc.text("Email", 23, linePoint + 8);
  tempLines = doc.splitTextToSize(
    _.get(statementLine, "licensee.MailAddress", ""),
    50
  );
  doc.text(tempLines, 50, linePoint + 8);
  addLines = tempLines.length - 1;

  doc.text("Email", 115, linePoint + 8);
  tempLines = doc.splitTextToSize(
    _.get(statementLine, "licensor.MailAddress", ""),
    50
  );
  doc.text(tempLines, 140, linePoint + 8);
  addLines = tempLines.length - 1;

  if (addLines > 0) {
    linePoint = linePoint + 4 * addLines;
  }
  linePoint += 2;

  linePoint += 15;

  return { linePoint, tempLines, addLines };
};
